const classData = [
{
    id: '1',
    title: '1. Intro to Python and Repl.it',
    description: 'Welcome to Intro to Python. In this first lesson we will learn about why we should learn Python, how we can use Repl.it to write our code, how to print to the screen, and how to leave comments for ourselves and other developers.',
    module: true,
    project: false,
},
{
    id: '2',
    title: '2. Variables and Data Types',
    description: 'Computer programs are all about data. Some type of input is passed into a program, the program acts on it in some way, and then some new output is passed back to the user. In this lesson we will learn about types of data we can work with in Python and how we can store this data in variables.',
    module: true,
    project: false,
},
{
    id: '3',
    title: '3. User Input',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 'madlibs',
    title: 'Project 1 - Mad Libs',
    description: 'It\'s time to have some fun! Use what you\'ve learned about data types, variables, user input and printing to create a Mad Libs Game.',
    projectNumber: '1',
    module: false,
    project: true,
},
{
    id: '4',
    title: '4. Booleans and Conditionals',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 5,
    title: '5. Chained and Nested Conditionals',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 6,
    title: '6. While Loops, Modules, and Random',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 'rocketlaunch',
    title: 'Project 2 - Rocket Launch',
    description: 'Coming Soon',
    projectNumber: '2',
    module: false,
    project: true,
},
{
    id: '7',
    title: '7. Lists',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 8,
    title: '8. For Loops',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 'battleship',
    title: 'Project 3 - 1D Battleship',
    description: 'Coming Soon',
    projectNumber: '3',
    module: false,
    project: true,
},
{
    id: '9',
    title: '9. Functions',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: '10',
    title: '10. Functions with Arguments and Return Statements',
    description: 'Coming Soon',
    module: true,
    project: false,
},
{
    id: 'camelrace',
    title: 'Project 4 - The Camel Race Game',
    description: 'Coming Soon',
    projectNumber: '4',
    module: false,
    project: true,
},
{
    id: 'capstone',
    title: 'Project 5 - Capstone',
    description: 'Coming Soon',
    projectNumber: '5',
    module: false,
    project: true,
}
];

export default classData;